<script>
    export default {
        data() {
            return {
                form: {
                    redirectUrl: '%2F%23%2F',
                    errorUrl: '',
                    partnerId: '',
                },
                loading: false
            }
        },
        methods: {
            submit() {
                this.loading = true;
                window.localStorage.partnerId = this.form.partnerId;
            }
        },
        created() {
            if (window.localStorage.partnerId) {
                this.form.partnerId = window.localStorage.partnerId;
            }
            // this.$store.dispatch('set_title', 'Авторизация');
        },
        watch: {},
        mounted() {
            this.$watch('$route.fullPath', ()=>{
                this.form.redirectUrl = window.location.href;
                console.log(this.form.redirectUrl);
            });
            this.form.redirectUrl = window.location.href;
            this.errorUrl = window.location.origin + '/tourclient/login.html';

        },
        components: {},
    }
</script>
<template>
    <div class="mag-login" v-loading="loading">
        <div class="mag-login__wrap">
            <div class="mag-login__box">
                <div class="mag-login__form">
                    <div class="mag-login__title">Вход в систему</div>
                    <form action="/tourclient/account/login" method="post">
                        <input name="redirectUrl" type="hidden" v-model="form.redirectUrl">
                        <input name="errorUrl" type="hidden" v-model="form.errorUrl">
                        <input name="partnerId" type="text" tabindex="1" v-model="form.partnerId"
                               placeholder="Id партнера">
                        <input name="login" type="text" tabindex="2" value="" placeholder="Введите ваш логин">
                        <input name="password" type="password" tabindex="3" value="" placeholder="Введите ваш пароль">
                        <div class="mag-login__buttons">
                            <input @click="submit" type="submit" value="Войти" tabindex="6">
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    .mag-login {
        min-height: 300px;
        position: relative;
        background: #e7d26f;

        &__wrap {
            width: 630px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
        &__box {
            padding: 0 0 0 300px;
            min-height: 255px;
            background: url('./img/bg.png') 0 50% no-repeat;
            input {
                border: none;
                cursor: text;
                width: 100%;
                display: block;
                height: 36px;
                color: #676767;
                font-weight: 300;
                font-size: 17px;
                margin: 8px 0;
                padding: 0 8px;
                outline: none;
            }
        }
        &__title {
            font-size: 46px;
            font-weight: 300;
            line-height: 0.8;
            color: #000;
            text-transform: none;
            padding: 0 0 14px 0;
        }
        &__buttons {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            a {
                text-decoration: underline;
                font-size: 18px;
                width: 160px;
                color: #0a9088;
                &:hover {
                    color: #0cb1a7;
                }
            }
            input {
                cursor: pointer;
                width: 131px;
                background: #7ac477;
                background: linear-gradient(to bottom, #7ac477 0%, #54a877 100%);
                height: 31px;
                line-height: 31px;
                padding: 0 20px;
                color: #fff;
                font-size: 16px;
                text-align: center;
                font-weight: 700;
                text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.18);
                box-shadow: 0 4px 0 rgba(0, 0, 0, .18);
                border-radius: 4px;
            }
        }
    }
</style>
